import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/2026/testimonials/testimonial-shard.png")